import coachListStore from '@modules/coach/coach-list-store';
import coachViewStore from '@modules/coach/coach-view-store';
import coachImporterStore from '@modules/coach/coach-importer-store';
import coachFormStore from '@modules/coach/coach-form-store';
import coachDestroyStore from '@modules/coach/coach-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: coachDestroyStore,
    form: coachFormStore,
    list: coachListStore,
    view: coachViewStore,
    importer: coachImporterStore,
  },
};
